/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Searchform_Loadinglong2Inputs */

const id_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kueri ini memakan waktu lebih lama dari biasanya...`)
};

const ms_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pertanyaan ini mengambil masa lebih lama daripada biasa...`)
};

const da_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne forespørgsel tager længere tid end normalt...`)
};

const de_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Abfrage dauert länger als üblich...`)
};

const en_us2_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This query is taking more than usual...`)
};

const es_es2_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta consulta está tardando más de lo habitual...`)
};

const es_mx2_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta consulta está tomando más tiempo de lo normal...`)
};

const fil_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang query na ito ay tumatagal nang mas mahaba kaysa karaniwan...`)
};

const fr_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette requête prend plus de temps que d'habitude…`)
};

const it_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa query sta impiegando più tempo del solito...`)
};

const hu_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez a lekérdezés a szokásosnál tovább tart...`)
};

const nl_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze query duurt langer dan normaal...`)
};

const no_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denne spørringen tar lengre tid enn vanlig...`)
};

const pl_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To zapytanie trwa dłużej niż zwykle...`)
};

const pt_br2_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This query is taking more than usual...`)
};

const pt_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta consulta está a demorar mais do que o habitual...`)
};

const ro_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Această interogare durează mai mult decât de obicei...`)
};

const fi_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä kysely kestää tavallista pidempään...`)
};

const sv_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denna fråga tar längre tid än vanligt...`)
};

const vi_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Truy vấn này đang mất nhiều thời gian hơn bình thường...`)
};

const tr_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu sorgu normalden daha uzun sürüyor...`)
};

const cs_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento dotaz trvá déle než obvykle...`)
};

const bg_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тази заявка отнема повече време от обикновено...`)
};

const ru_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Этот запрос выполняется дольше обычного...`)
};

const uk_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цей запит виконується довше, ніж зазвичай...`)
};

const ar_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا الاستعلام يستغرق وقتًا أطول من المعتاد...`)
};

const hi_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह क्वेरी अधिक समय ले रही है...`)
};

const th_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คิวรีนี้ใช้เวลานานกว่าปกติ...`)
};

const ja_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このクエリは通常より時間がかかっています...`)
};

const zh_cn2_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This query is taking more than usual...`)
};

const zh_hant1_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This query is taking more than usual...`)
};

const ko_components_searchform_loadinglong2 = /** @type {(inputs: Components_Searchform_Loadinglong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This query is taking more than usual...`)
};

/**
* | output |
* | --- |
* | "This query is taking more than usual..." |
*
* @param {Components_Searchform_Loadinglong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_searchform_loadinglong2 = /** @type {((inputs?: Components_Searchform_Loadinglong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Searchform_Loadinglong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_searchform_loadinglong2(inputs)
	if (locale === "ms") return ms_components_searchform_loadinglong2(inputs)
	if (locale === "da") return da_components_searchform_loadinglong2(inputs)
	if (locale === "de") return de_components_searchform_loadinglong2(inputs)
	if (locale === "en-US") return en_us2_components_searchform_loadinglong2(inputs)
	if (locale === "es-ES") return es_es2_components_searchform_loadinglong2(inputs)
	if (locale === "es-MX") return es_mx2_components_searchform_loadinglong2(inputs)
	if (locale === "fil") return fil_components_searchform_loadinglong2(inputs)
	if (locale === "fr") return fr_components_searchform_loadinglong2(inputs)
	if (locale === "it") return it_components_searchform_loadinglong2(inputs)
	if (locale === "hu") return hu_components_searchform_loadinglong2(inputs)
	if (locale === "nl") return nl_components_searchform_loadinglong2(inputs)
	if (locale === "no") return no_components_searchform_loadinglong2(inputs)
	if (locale === "pl") return pl_components_searchform_loadinglong2(inputs)
	if (locale === "pt-BR") return pt_br2_components_searchform_loadinglong2(inputs)
	if (locale === "pt") return pt_components_searchform_loadinglong2(inputs)
	if (locale === "ro") return ro_components_searchform_loadinglong2(inputs)
	if (locale === "fi") return fi_components_searchform_loadinglong2(inputs)
	if (locale === "sv") return sv_components_searchform_loadinglong2(inputs)
	if (locale === "vi") return vi_components_searchform_loadinglong2(inputs)
	if (locale === "tr") return tr_components_searchform_loadinglong2(inputs)
	if (locale === "cs") return cs_components_searchform_loadinglong2(inputs)
	if (locale === "bg") return bg_components_searchform_loadinglong2(inputs)
	if (locale === "ru") return ru_components_searchform_loadinglong2(inputs)
	if (locale === "uk") return uk_components_searchform_loadinglong2(inputs)
	if (locale === "ar") return ar_components_searchform_loadinglong2(inputs)
	if (locale === "hi") return hi_components_searchform_loadinglong2(inputs)
	if (locale === "th") return th_components_searchform_loadinglong2(inputs)
	if (locale === "ja") return ja_components_searchform_loadinglong2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_searchform_loadinglong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_searchform_loadinglong2(inputs)
	return ko_components_searchform_loadinglong2(inputs)
});
export { components_searchform_loadinglong2 as "components.searchForm.loadingLong" }